import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './registerServiceWorker'
import './services/GlobalVariables'
import './assets/fonts/icons.js'
import router from './router'
import store from './store'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import DrawerLayout from 'vue-drawer-layout'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueGoodTablePlugin from 'vue-good-table';
// import the styles
import 'vue-good-table/dist/vue-good-table.css'

// Import stylesheet
Vue.use(VueGoodTablePlugin);
Vue.use(DrawerLayout);
Vue.component('loading', Loading);
Vue.component('v-select',vSelect)
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
